import { call, put, takeLeading } from 'redux-saga/effects';
import { FETCH_LANDING_DATA, SET_LANDING_DATA } from 'store/key';
import { produce } from 'utility/general';
import api from 'api/call';
import { safeSaga } from 'store';

const initialState = { application: [], postApprovalDocument: [], isLoading: false, isError: false };

function* getLandingData(action) {
    const { role } = action.payload;

    try {
        yield put({ type: SET_LANDING_DATA, payload: { isLoading: true, isError: false } });
        const response = yield call(api.landing.getLandingData, role);
        yield put({ type: SET_LANDING_DATA, payload: { ...response.data.result, isLoading: false } });
    } catch (error) {
        yield put({ type: SET_LANDING_DATA, payload: { isError: true, isLoading: false } });
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANDING_DATA:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchLanding() {
    yield takeLeading(FETCH_LANDING_DATA, safeSaga(getLandingData));
}

export default reducer;
